function getArrayBuffer(evt) {
  if (evt.data instanceof ArrayBuffer) {
    return Promise.resolve(evt.data);
  } else if (evt.data instanceof Blob) {
    return evt.data.arrayBuffer();
  } else {
    return Promise.resolve(null);
  }
}
export class MsgRelayClient {
  constructor(ws) {
    this.ws = ws;
    this.inBuf = [];
    this.waiter = null;
  }
  inBuf;
  waiter;
  wsClose() {
    this.ws.close();
  }
  async close() {
    if (this.ws.readyState == 3) {
      return Promise.resolve(true);
    }
    return new Promise((resolve) => {
      this.ws.onclose = () => {
        resolve(true);
      };
      this.ws.close();
    });
  }
  send(msg) {
    this.ws.send(msg);
  }
  next() {
    if (this.inBuf.length > 0) {
      return Promise.resolve(this.inBuf.pop());
    } else {
      return new Promise((resolve) => {
        this.waiter = resolve;
      });
    }
  }
  static async connect(endpoint, signal) {
    const { promise, resolve, reject } = Promise.withResolvers();
    if (signal && signal.aborted) {
      reject(signal.reason);
    }
    const ws = new WebSocket(endpoint);
    const relay = new MsgRelayClient(ws);
    ws.binaryType = "arraybuffer";
    ws.onmessage = (evt) => {
      getArrayBuffer(evt).then((data) => {
        if (!data) {
          return;
        }
        let msg = new Uint8Array(data);
        let waiter = relay.waiter;
        relay.waiter = null;
        if (waiter) {
          waiter(msg);
        } else {
          relay.inBuf.push(msg);
        }
      });
    };
    ws.onopen = () => {
      ws.onerror = null;
      resolve(relay);
    };
    ws.onerror = (evt) => {
      reject(evt);
    };
    if (signal) {
      signal.onabort = () => {
        ws.close();
      };
    }
    return promise;
  }
}
